import React from "react";
import { SelectField, InputField } from "../../components/ui/UIComponents";

// ─────────────────────────────────────────────────────────────────────────────
// STEP 3 — Family Background
// ─────────────────────────────────────────────────────────────────────────────

const INCOME_OPTIONS = [
  "Below ₹10,000 / month",
  "₹10,000 – ₹30,000 / month",
  "₹30,000 – ₹60,000 / month",
  "₹60,000 – ₹1,00,000 / month",
  "Above ₹1,00,000 / month",
];

const OCCUPATION_OPTIONS = [
  "Farming / Agriculture",
  "Daily Wage Labour",
  "Small Business / Shop Owner",
  "Government Job (Class III / IV)",
  "Government Job (Officer Level)",
  "Private Sector Employee",
  "Doctor / Lawyer / Professional",
  "Self-Employed",
  "Retired",
  "Deceased / Single Parent",
];

const incomeColor = income => {
  if (!income) return null;
  if (income.includes("1,00,000")) return "#10b981";
  if (income.includes("60,000")) return "#22d3ee";
  if (income.includes("30,000")) return "#f59e0b";
  return "#ef4444";
};

const incomeAdvice = income => {
  if (!income) return null;
  if (income.includes("1,00,000")) return "✅ Strong financial base — premium course options available";
  if (income.includes("60,000")) return "🟡 Moderate income — consider scholarships for premium courses";
  if (income.includes("30,000")) return "🟠 Limited budget — free platforms (NPTEL, FreeCodeCamp) recommended";
  return "🔴 Low income bracket — scholarship schemes & free certifications essential";
};

export default function Step3Family({ form, setForm }) {
  const update = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const iColor  = incomeColor(form.parentIncome);
  const iAdvice = incomeAdvice(form.parentIncome);

  return (
    <div>
      {/* Parent Income */}
      <SelectField
        label="Parents' Monthly Income" required
        value={form.parentIncome}
        onChange={v => update("parentIncome", v)}
        options={INCOME_OPTIONS}
        hint="Used to calculate financial feasibility and scholarship recommendations"
      />

      {/* Income insight card */}
      {iColor && (
        <div style={{
          marginTop: -8, marginBottom: 16,
          padding: "10px 14px",
          background: `${iColor}0f`,
          border: `1px solid ${iColor}35`,
          borderRadius: 8,
          fontSize: 12, color: iColor,
          fontFamily: "Exo 2, sans-serif", lineHeight: 1.5,
        }}>
          {iAdvice}
        </div>
      )}

      {/* Family Occupation */}
      <SelectField
        label="Parents' Occupation"
        value={form.familyOccupation}
        onChange={v => update("familyOccupation", v)}
        options={OCCUPATION_OPTIONS}
      />

      {/* Financial Support */}
      <SelectField
        label="Financial Support Available?" required
        value={form.financialSupport}
        onChange={v => update("financialSupport", v)}
        options={[
          "Yes — Full Support from Family",
          "Yes — Partial Support (Self + Family)",
          "No — Fully Self-Dependent",
          "Scholarship / Loan Required",
          "Education Loan Already Taken",
        ]}
      />

      {/* Dependents */}
      <SelectField
        label="Number of Dependents in Family"
        value={form.dependents}
        onChange={v => update("dependents", v)}
        options={["1–2 members","3–4 members","5–6 members","7+ members"]}
        hint="Helps assess financial pressure and urgency to earn"
      />

      {/* First Gen */}
      <SelectField
        label="Are you the first in family to graduate?"
        value={form.firstGen}
        onChange={v => update("firstGen", v)}
        options={["Yes — First Generation Graduate","No — Parents/Siblings also graduated"]}
      />

      {/* Govt Category */}
      <SelectField
        label="Category (for Scholarship / Reservation)"
        value={form.category}
        onChange={v => update("category", v)}
        options={["General","OBC","SC","ST","EWS","Minority","Other"]}
        hint="Used only for scholarship and scheme recommendations"
      />
    </div>
  );
}